/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { PrimaryCarousel } from '@powdr/components';

import { SlideItem } from './components';
import { StyledSlider } from './styles';

export const Slider = ({
  className = '',
  isThumbnailsDisabled = false,
  additionalControls = {},
  parentColorProfile,
  relationships,
}) => {
  const { slides } = relationships;
  const slidesAdjusted = (slides.length === 2) ? slides.concat(slides) : slides;

  const SlideMap = () => useMemo(() => slidesAdjusted.map((item) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SlideItem {...item} />
  )), []);

  return (
    <StyledSlider className={`${className} slider`}>
      {(slides.length > 1)
        ? (
          <PrimaryCarousel
            colorProfile={parentColorProfile}
            isShowThumbnails={!isThumbnailsDisabled}
            isAutoRotate={false}
            {...additionalControls}
          >
            {SlideMap()}
          </PrimaryCarousel>
        ) : (
          SlideMap()
        )}
    </StyledSlider>
  );
};

Slider.propTypes = {
  className: PropTypes.string,
  isThumbnailsDisabled: PropTypes.bool,
  relationships: PropTypes.shape().isRequired,
  parentColorProfile: PropTypes.string.isRequired,
  additionalControls: PropTypes.shape({}),
};
